export const initialState = {
  activeStep: "systems",
  address: {
    address_1: "",
    address_2: "",
    city: "",
    state: "",
    zip: "",
    county: "",
  },
  coisGood: true,
  coRenter: null,
  dealer: null,
  defaultPricebook: true,
  downPaymentOverrideAmount: 0,
  driversLicense: null,
  error: null,
  id: null,
  initLoading: true,
  loading: true,
  payment: null,
  paymentSkipped: false,
  paymentTransactions: [],
  pdfFilename: "",
  proofOfIncome: null,
  proofOfResidence: null,
  remoteCode: false,
  remoteEmail: "",
  renter: {
    address_1: "",
    address_2: "",
    birthdate: null,
    city: "",
    drivers_license: "",
    email: "",
    employer_address_1: "",
    employer_address_2: "",
    employer_city: "",
    employer_name: "",
    employer_phone: "",
    employer_state: "",
    employer_zip: "",
    first_name: "",
    home_phone: "",
    id: null,
    last_name: "",
    middle_name: "",
    references: [
      {
        id: null,
        email: "",
        first_name: "",
        last_name: "",
        phone: "",
        relationship: "",
      },
      {
        id: null,
        email: "",
        first_name: "",
        last_name: "",
        phone: "",
        relationship: "",
      },
    ],
    state: "",
    zip: "",
  },
  salesperson: null,
  showPricebookSelect: false,
  showRemoteSuccess: false,
  showSuccess: false,
  statedIncome: "",
  status: 0,
  systems: [],
  term: {
    additionalCost: "",
    additionalCostNote: "",
    downPayment: "",
    purchaseReserveReduction: "",
    taxCounty: "",
    taxState: "",
    taxZip: "",
    selected: null,
  },
  // voidedCheck: null
};
